<template lang="html">
  <div class="">
    <v-form ref="form">
      <v-slide-y-transition group>
        <template v-for="section in sections">
          <!-- <template v-for="section in sections" v-if="_show(section.condition)"> -->
          <v-flex
            v-if="section.title"
            :key="section.id"
            mt-4
          >
            <v-layout
              ma-0
              align-center
            >
              <span class="headline font-weight-light">{{ _templateLiteralString(section.title) }}</span>
              <SiHelpIcon
                v-if="section.help"
                :help-text="section.help"
                color="info"
                icon-class="ml-2"
              />
            </v-layout>
            <v-divider />
            <v-flex
              xs12
              px-0
              pb-3
            >
              {{ _templateLiteralString(section.description) }}
            </v-flex>
          </v-flex>

          <template v-for="fieldName in section.fields">
            <v-flex
              :key="fieldName"
              xs12
              pa-0
            >
              <v-expand-transition>
                <v-flex
                  v-if="_show(field(fieldName).condition) && field(fieldName).inputType !=='SiMultiItemInput' && field(fieldName).inputType !== 'SiInputCalculated'"
                  xs12
                  pa-0
                >
                  <SiInputWrapper
                    v-bind="field(fieldName)"
                    :key="fieldName"
                    apply-layout
                    help-spacing
                  >
                    <component
                      :is="field(fieldName).inputType"
                      v-bind="field(fieldName)"
                      :value="cData[fieldName]"
                      :label="_templateLiteralString(field(fieldName).label)"
                      :items="_evaluateItems(field(fieldName).items)"
                      :rules="_rules(field(fieldName).rules)"
                      :min="_min(field(fieldName).min, field(fieldName).format)"
                      :max="_max(field(fieldName).max, field(fieldName).format)"
                      filled
                      @change="canthandlethis(fieldName, $event)"
                    />
                  </SiInputWrapper>
                </v-flex>
              </v-expand-transition>

              <div v-if="field(fieldName).inputType === 'SiInputCalculated'">
                <SiInputCalculated
                  v-model="cData[fieldName]"
                  :formula="field(fieldName).formula"
                  :c-data="cData"
                />
              </div>

              <div v-if="_show(field(fieldName).condition) && field(fieldName).inputType ==='SiMultiItemInput'">
                <SiMultiItemInput
                  v-model="cData[fieldName]"
                  :fields="getFieldArray(field(fieldName).fields)"
                  v-bind="field(fieldName)"
                  :c-data="cData"
                />
              </div>
            </v-flex>
          </template>
        </template>
      </v-slide-y-transition>
      <v-flex
        v-if="hasForm"
        pa-0
      >
        <v-layout
          v-if="!assisted && !test"
          row
          wrap
        >
          <v-flex xs12>
            <v-divider />
          </v-flex>
          <v-flex xs12>
            <v-layout
              align-center
              ma-0
            >
              <v-checkbox
                v-model="disclaimer"
                label="I confirm that I have read and agree to the disclaimer"
                class="mt-5"
                :rules="[v => !!v || 'You must confirm that you have read and agree to the disclaimer before you can continue']"
              />
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="dialog = true"
              >
                disclaimer
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-divider />
          </v-flex>
        </v-layout>

        <v-divider v-else />

        <v-expand-transition>
          <div v-if="showErrorAlert">
            <v-alert
              type="warning"
              outlined
              prominent
              border="left"
              class="my-4"
            >
              <div class="font-weight-bold">
                {{ errorCnt }} ERROR{{ errorCnt > 1 ? 'S' : '' }}
              </div>
              Opps, there {{ errorCnt > 1 ? 'are' : 'is' }} {{ errorCnt }} error{{ errorCnt > 1 ? 's' : '' }} in the information you have entered. Please see the errors messages above and correct them before continuing
              <v-expand-transition>
                <div
                  v-if="canHaveAssistance && calculateTries > 1"
                  class="mt-4"
                >
                  If you continue to experience issues, we offer an assistance service for this calculation. For a small fee we can check your information and complete this calculation on your behalf.
                  <div class="my-2">
                    <v-btn
                      color="warning"
                      outlined
                      :href="`/assistance?calculator=${$route.params.calculator}&variant=${$route.params.variant}`"
                      target="blank"
                    >
                      Get Assistance<v-icon right>
                        arrow_forward
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-expand-transition>
            </v-alert>
          </div>
        </v-expand-transition>
        <v-layout
          wrap
          my-3
        >
          <v-spacer />
          <v-flex shrink>
            <v-btn
              :color="showErrorAlert ? 'warning' : 'primary'"
              :disabled="hasDataError"
              large
              @click="calculate"
            >
              {{ showErrorAlert ? 'fix errors' : 'calculate' }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>

    <v-dialog
      v-model="dialog"
      width="600"
      scrollable
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Calculator Disclaimer
        </v-card-title>
        <v-card-text v-html="calculatorInfo.disclaimer" />
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="acceptDisclaimer"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { isArray, forEach, cloneDeep } from 'lodash'
import helpers from '@/mixins/helpers'
import conditions from '@/mixins/conditions'
import validations from '@/mixins/validations'
import field from '@/mixins/field'

export default {
  mixins: [ helpers, conditions, validations, field ],
  props: {
    calculator: {
      type: Object,
      default: () => ({})
    },
    calculationData: {
      type: Object,
      default: () => ({})
    },
    report: {
      type: Object,
      default: () => ({})
    },
    calculatorInfo: {
      type: Object,
      default: () => ({})
    },
    canHaveAssistance: Boolean,
    assisted: Boolean,
    test: Boolean
  },
  data () {
    return {
      dialog: false,
      disclaimer: false,
      cData: cloneDeep(this.calculationData),
      initialSection: [],
      forms: {},
      fields: {},
      isMounted: false,
      calculateTries: 0,
      showErrorAlert: false
    }
  },
  computed: {
    ...mapGetters(['_inputTypes']),
    errorCnt () {
      if (this.isMounted) {
        return Object.values(((this.$refs.form || {})._data || {}).errorBag || {}).filter(i => Boolean(i)).length
        // return Object.keys(((this.$refs.form || {})._data || {}).errorBag || {}).length
      }
      return 0
    },
    hasDataError () {
      var hasError = false
      forEach(this.cData, (value, name) => {
        if (name.substring(0, 5) === 'error' && value) hasError = true
      })
      return hasError
    },
    formId () {
      let formId = null
      forEach(this.forms, form => {
        if (this._show(form.condition) && form.condition) {
          formId = form.id
        }
      })
      return formId
    },
    hasForm () {
      return Boolean(this.formId)
    },
    sections () {
      var sections = []
      const getForm = forms => {
        var formData = {}
        forEach(forms, form => {
          if (this._show(form.condition) && form.condition) {
            formData = form
          }
        })
        return formData
      }

      var form = getForm(this.forms)
      sections = sections.concat(this.initialSection)
      sections = sections.concat(this._sortObject(form.sections, 'index'))
      return sections.filter(s => this._show(s.condition))
    },
  },
  watch: {
    formId () {
      this.resetData()
    },
    calculator () {
      this.syncCalculator()
    },
    calculationData: {
      handler: function (v) {
        this.cData = cloneDeep(v)
        this.showErrorAlert = false
      },
      deep: true,
      instant: true
    },
    disclaimer () {
      this.showErrorAlert = false
    }
    // cData: {
    //   deep: true,
    //   handler: function () {
    //     this.$emit('update:cData', this.cData)
    //   }
    // }
  },
  beforeMount () {
    this.syncCalculator()
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    acceptDisclaimer () {
      this.dialog = false
      this.disclaimer = true
    },
    canthandlethis (fieldName, e) {
      this.$set(this.cData, fieldName, e)
      this.$nextTick(() => {
        this.$emit('update:calculationData', this.cData)
      })
    },
    calculate () {
      setTimeout(() => {
        this.$vuetify.goTo(document.body.scrollHeight, { duration: 200 })
      }, 10) // so the alert will be visible

      this.calculateTries++

      if (!this.$refs.form.validate()) {
        this.showErrorAlert = true
        return
      }

      let report = this._removeUndefined(this.generateReport())
      let calculationData = this._removeUndefined(this.cData)

      this.$emit('update:report', report)
      this.$emit('calculate', { calculationData: calculationData, report: report })
    },
    getFieldArray (fieldList) {
      return fieldList.map(x => { return this.field(x) })
    },
    field (fieldName) {
      return this.fields[fieldName] || {}
    },
    resetData () {
      let carryOver = {}
      
      if (this.test) return 

      forEach(this.initialSection, section => {
        forEach(section.fields, field => {
          carryOver[field] = this.cData[field]
        })
      })

      forEach(this.cData, (v, k) => {
        if (k.substring(0, 1) === '_') carryOver[k] = v
      })

      this.cData = carryOver
      this.$emit('update:calculationData', carryOver)
      this.$refs.form.resetValidation()
    },
    syncCalculator () {
      var mapping = (this.calculator || {}).mapping || {}
      this.fields = this.calculator.fields
      this.forms = mapping.forms
      this.initialSection = this._sortObject(mapping.initialSection, 'index')
    },
    hasItems (inputType) {
      return Boolean(((this._inputTypes[inputType] || {}).attrs || {}).items)
    },
    generateReport () {
      let report = this._removeUndefined(this.parseReportData())
      return {
        assumptions: report.sections,
        data: report.data
      }
    },
    parseReportData () {
      const checkNil = (value) => {
        if (value === 'undefined' || value === undefined || value === null) return 'nil'
        return value
      }
      var sections = {}
      var reportData = {}
      forEach(cloneDeep(this.sections), (s, i) => {
        // loop through each section defined for this calculation and form
        var fields = []

        if (!this._show(s.condition)) return

        forEach(s.fields, fieldId => {
          // loop through every field in that section and push it to the report if it is shown on the form and should be visible on the report
          let field = this.field(fieldId)

          if (!this._show(field.condition)) return
          // if (this._show(field.condition)) {

          // FUNCTION for evaluating and formating value
          const parseValue = (v, parsedField, valueId = 'text') => {
            // get the value or set it to 'nil'
            // var v = this.cData[fieldId] || checkNil(this.cData[fieldId])

            v = checkNil(v)
            // return the value if it's now nil
            if (v === 'nil') return v

            // if an field has items need to filter it's items to get the text to show on the report field
            if (this.hasItems(parsedField.inputType)) {
              const filterForValue = (v) => {
                return ((parsedField.items.filter(i => { return i.value === v }) || [])[0] || {})[valueId]
              }

              // if the field has multiple enabled then value should be array. Need to iterate array and repalce each value with the text
              if (isArray(v)) {
                v = v.map(x => { return filterForValue(x) })
              } else {
                // else just filter through items to find item text
                v = filterForValue(v)
              }
            }
            return this._formatValue(v, parsedField.format)
          }

          if ((field.inputType || '').substring(0, 7) === 'SiInput' && (field.inputType || '') !== 'SiMultiItemInput') {
            // if it's an input field push it as is
            let reportValue = parseValue(this.cData[fieldId], field)
            let reportField = {
              label: (field.inputType || '') === 'SiInputCalculated' ? field.reportLabel : field.reportLabel || this._templateLiteralString(field.label),
              value: reportValue,
              multiple: isArray(reportValue),
              type: 'input'
            }
            // only push the field to the report if it has not been set to hide
            if (!field.reportHide) fields.push(reportField)
            //  push the data item to data ojbect. This data is used for referencing in the report and conditions
            reportData[fieldId] = {
              value: this.cData[fieldId],
              text: reportValue,
              ...(this.hasItems(field.inputType) ? { subtext: parseValue(this.cData[fieldId], field, 'subtext') } : {})
            }
          } else if ((field.inputType || '') === 'SiMultiItemInput') {
            let multi = { labels: [], values: [] }
            // if its a multi loop through each of the rows that have been added
            forEach(this.cData[fieldId], (multiField) => {
              let labels = []
              let values = []
              forEach(multiField, (value, key) => {
                // create a labels array that will be a single array used first
                // push each row of values to the values array
                // let format = ''
                let reportValue = parseValue(value, this.field(key))
                labels.push(this._templateLiteralString(this.field(key).reportLabel) || this._templateLiteralString(this.field(key).label))
                // values.push({ value: value || checkNil(value), format: this.field(key).format })
                values.push(reportValue)
              })
              multi.labels = labels //  labels is overwritten each time because we only need one row of labels
              multi.values.push(values)
            })

            multi.label = this._templateLiteralString(field.reportLabel) || this._templateLiteralString(field.label)
            multi.type = 'multi'
            fields.push(multi)
          }
          // }
        })
        sections[s.id] = {
          index: i,
          label: s.reportLabel || s.title,
          fields: fields,
          type: 'section'
        }
      })
      // loop through and get any private data and add it to the data object. Values such as _variant are used for conditions by the report
      forEach(this.cData, (d, k) => {
        if (k.substring(0, 1) === '_') {
          reportData[k] = {
            value: d,
            text: d
          }
        }
      })
      return { sections: sections, data: reportData }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
